export default "__VITE_ASSET__BKj6w129__"